export const REGISTRATION_DATA_LOADED = "REGISTRATION_DATA_LOADED";
export const REGISTRATION_SUCCEEDED = "REGISTRATION_SUCCEEDED";
export const VERIFICATION_SUCCEEDED = "VERIFICATION_SUCCEEDED";
export const VERIFICATION_FAILED = "VERIFICATION_FAILED";
export const BRANDING_RECEIVED = "BRANDING_RECEIVED";
export const PUSH_NOTIFICATION_TO_QUEUE = "PUSH_NOTIFICATION_TO_QUEUE";
export const REMOVE_NOTIFICATION_FROM_QUEUE = "REMOVE_NOTIFICATION_FROM_QUEUE";
export const OPEN_SUPPORT = "OPEN_SUPPORT";
export const CLOSE_SUPPORT = "CLOSE_SUPPORT";
export const TOKEN_USED = "TOKEN_USED";
export const RESET_TOKEN = "RESET_TOKEN";
export const RE_SEND_OTP_SUCCEEDED = "RE_SEND_OTP_SUCCEEDED";
export const RE_SEND_OTP_FAILED = "RE_SEND_OTP_FAILED";